
import { Component } from "vue-property-decorator";
import news from "@/views/kaizhou-shuai-video/news.vue";

@Component({
  name: "hotNews"
})
export default class hotNews extends news {}
